import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trophy, Smartphone, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const monthLabel = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("it-IT", { month: "long", year: "numeric" });
};
const lastMonths = (n = 12) => Array.from({ length: n }, (_, i) => { const x = new Date(); x.setDate(1); x.setMonth(x.getMonth() - i); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}`; });
const MEDAL = ["text-amber-400", "text-slate-300", "text-orange-400"];

export function PartnerLeaderboard() {
  const navigate = useNavigate();
  const [month, setMonth] = useState(lastMonths(1)[0]);
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.partnerLeaderboard(month).then(setData).catch(() => setData({ rows: [], totals: {} })); }, [month]);
  if (data && data.rows.length === 0 && month === lastMonths(1)[0] && !data.has_partners) return null;
  return (
    <Card className="p-5 bg-card border-border mt-5" data-testid="partner-leaderboard">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="flex-1 min-w-[220px]">
          <h3 className="font-display font-bold flex items-center gap-2"><Trophy className="h-4 w-4 text-sky-400" /> Classifica partner</h3>
          <p className="text-xs text-muted-foreground">App di terzi ordinate per giocate e vincite del mese{data?.totals?.plays ? ` · ${data.totals.plays} giocate, ${data.totals.wins} vincite` : ""}.</p>
        </div>
        <select data-testid="partner-leaderboard-month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-10 rounded-md border border-border bg-background px-3 text-sm capitalize">
          {lastMonths().map((m) => <option key={m} value={m}>{monthLabel(m)}</option>)}
        </select>
        <Button variant="secondary" className="gap-2" onClick={() => navigate("/partner")} data-testid="partner-leaderboard-open">Partner & API <ArrowRight className="h-4 w-4" /></Button>
      </div>
      {!data && <p className="text-sm text-muted-foreground">Caricamento…</p>}
      {data?.rows.length === 0 && <p className="text-sm text-muted-foreground" data-testid="partner-leaderboard-empty">Nessuna giocata da app partner nel mese selezionato.</p>}
      {data?.rows.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="partner-leaderboard-table">
            <thead className="text-xs uppercase tracking-wider text-muted-foreground">
              <tr className="border-b border-border"><th className="text-left py-2 pr-3">#</th><th className="text-left py-2 pr-3">Partner</th><th className="text-right py-2 px-3">Giocate</th><th className="text-right py-2 px-3">Vincite</th><th className="text-right py-2 px-3">% vincita</th><th className="text-right py-2 px-3">Ritirati</th><th className="text-right py-2 pl-3">Utenti</th></tr>
            </thead>
            <tbody>
              {data.rows.map((r, i) => (
                <tr key={r.partner_id} className="border-b border-border/50 hover:bg-secondary/30" data-testid={`partner-leaderboard-row-${r.rank}`}>
                  <td className={`py-2 pr-3 font-bold ${MEDAL[i] || "text-muted-foreground"}`}>{r.rank}</td>
                  <td className="py-2 pr-3 font-semibold flex items-center gap-2"><Smartphone className="h-3.5 w-3.5 text-muted-foreground" /> {r.partner_name}</td>
                  <td className="py-2 px-3 text-right font-mono-code">{r.plays}</td>
                  <td className="py-2 px-3 text-right font-mono-code text-emerald-400">{r.wins}</td>
                  <td className="py-2 px-3 text-right font-mono-code">{r.win_rate}%</td>
                  <td className="py-2 px-3 text-right font-mono-code">{r.redeemed}</td>
                  <td className="py-2 pl-3 text-right font-mono-code">{r.users}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
